import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/about-ripple.png'
import _imports_1 from '../../images/wave.png'
import _imports_2 from '../../images/close-white.png'
import _imports_3 from '../../images/mascot-2.png'


const _withScopeId = n => (_pushScopeId("data-v-4e489c68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "box-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "wave-icon"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "wave-icon wave-icon-2"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 이달의 바다 활동 누적 수치 ", -1))
const _hoisted_6 = { class: "list d-flex justify-content-between" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 활동 진행 횟수 ", -1))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "num" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "회", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 활동 참여 인원 ", -1))
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "num" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "명", -1))
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 수거 폐기물 양 ", -1))
const _hoisted_19 = { class: "content" }
const _hoisted_20 = { class: "num" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "kg", -1))
const _hoisted_22 = { class: "map-container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" 이달의 바다에서"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 함께한 오늘의 실천 ")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "wave-icon"
}, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "wave-icon wave-icon-2"
}, null, -1))
const _hoisted_26 = { class: "map" }
const _hoisted_27 = ["src"]
const _hoisted_28 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_29 = { class: "relative" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "hover-bg" }
const _hoisted_32 = { class: "board" }
const _hoisted_33 = { class: "relative" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "location-text" }
const _hoisted_36 = ["src", "onClick"]
const _hoisted_37 = { class: "board-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 활동 진행 횟수 ", -1))
const _hoisted_39 = { class: "content" }
const _hoisted_40 = { class: "num" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "회", -1))
const _hoisted_42 = { class: "board-item" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 활동 참여 인원 ", -1))
const _hoisted_44 = { class: "content" }
const _hoisted_45 = { class: "num" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "명", -1))
const _hoisted_47 = { class: "board-item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 수거 폐기물 양 ", -1))
const _hoisted_49 = { class: "content" }
const _hoisted_50 = { class: "num" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "kg", -1))
const _hoisted_52 = { class: "location-text" }
const _hoisted_53 = ["src", "onClick"]
const _hoisted_54 = { class: "d-md-none" }
const _hoisted_55 = { class: "message-container" }
const _hoisted_56 = { class: "title" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" 이달의 바다 활동에")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = { class: "header-wrapper" }
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-line" }, null, -1))
const _hoisted_62 = { class: "mobile-board-container" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 이달의 바다 현장 사진 ", -1))
const _hoisted_64 = { class: "banners d-flex" }
const _hoisted_65 = ["src"]
const _hoisted_66 = ["src"]
const _hoisted_67 = ["src"]
const _hoisted_68 = ["src"]
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" 다음")
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "strong" }, " 이달의 바다 ", -1))
const _hoisted_71 = /*#__PURE__*/_createTextVNode("활동 참여하기 ")
const _hoisted_72 = { class: "board-container d-none d-md-block" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "wave-icon"
}, null, -1))
const _hoisted_74 = { class: "board" }
const _hoisted_75 = { class: "title" }
const _hoisted_76 = { class: "header-wrapper" }
const _hoisted_77 = ["src"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 이달의 바다 현장 사진 ", -1))
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 다음")
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "strong" }, " 이달의 바다 ", -1))
const _hoisted_81 = /*#__PURE__*/_createTextVNode("활동 참여하기 ")
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "mascot"
}, null, -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-dialog" }, null, -1))
const _hoisted_84 = [
  _hoisted_83
]

import { ref, onMounted, reactive, watch } from 'vue';
  import { Modal } from 'bootstrap';
  import EmartBtn from '../emart-btn.vue';
  import { IEmartProgram } from '../../type';
  import { isMobile } from '@/utils';
  import SwiperVue from './swiper.vue';
  import WaitDialogVue from '../wait-dialog.vue';

  export interface IProps {
    program: IEmartProgram
  }type Location = {
    top: number;
    left: number;
    name: string;
    key: string;
    active?: boolean;
    show?: boolean;
    activityCount?: number; // 活动数量
    joinCount?: number; // 参与活动人数
    collectionCount?: number; // 收集数量
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
    program: IEmartProgram
  }

  ;

  
  const isMobileApp = isMobile();
  const modalRef = ref();
  const showWaitDialog = ref(false);
  let modalInstance: Modal;
  const mapWidth = 1386;
  const mapHeight = 1481;
  const mapLocationList = reactive<Location[]>([]);
  // 坐标，顺时针 部分坐标微调修正
  const locationPosition: Location[] = [
    { top: 140, left: 893, name: '양양', key: 'mp_yangyang' },
    { top: 232, left: 441, name: '인천', key: 'mp_incheon'  },
    // 删除了，先放着，免得要
    // { top: 667, left: 1036, name: '포항', key: 'mp_pohang' },
    { top: 880, left: 893, name: '부산', key: 'mp_busan' },
    { top: 908, left: 641, name: '광양', key: 'mp_gwangyang' },
    { top: 956, left: 577, name: '순천', key: 'mp_suncheon' },
    { top: 994, left: 641, name: '여수', key: 'mp_yeosu' },
    { top: 982, left: 378, name: '목포', key: 'mp_mokpo' },
    { top: isMobileApp ? 1310 : 1333, left: 378, name: '제주', key: 'mp_jeju' },
    { top: isMobileApp ? 1340 : 1368, left: 435, name: '서귀포', key: 'mp_seogwipo' },
    { top: isMobileApp ? 645 : 680, left: 430, name: '군산', key: 'mp_gunsan' },
  ];
  const locationIcon = require('../../images/location.png');
  const locationActiveIcon = require('../../images/location-active.png');

  function getLocationStyle(item: Location) {
    return {
      top: `${item.top}%`,
      left: `${item.left}%`
    };
  }

  function getLocationIcon(item: Location) {
    if (item.show) {
      return isMobileApp ? locationActiveIcon : locationIcon;
    }
    return item.active ? locationActiveIcon : locationIcon;
  }

  onMounted(() => {
    modalInstance = new Modal(modalRef.value, {
      keyboard: false,
      backdrop: 'static'
    });
  });

  function updateLocation() {
    const configs = props.program?.custom_key?.configs || {};
    locationPosition.forEach((item, index) => {
      mapLocationList[index] = {
        top: Number((item.top / mapHeight * 100).toFixed(2)),
        left: Number((item.left / mapWidth * 100).toFixed(2)),
        name: item.name,
        key: item.key,
        active: false,
        show: false,
        activityCount: configs[`${item.key}_activity_count`]?.value,
        joinCount: configs[`${item.key}_join_count`]?.value,
        collectionCount: configs[`${item.key}_collection_count`]?.value,
      };
    });
  }

  function handleHoverLocationName(item: Location, active: boolean) {
    if (isMobileApp || item.show) {
      return;
    }
    item.active = active;
  }

  function handleClickLocationName(item: Location) {
    if (!isMobileApp) {
      return;
    }
    item.active = !item.active;
    triggerLocation(item);
  }

  function triggerLocation(item: Location) {
    item.show = !item.show;
    if (item.show) {
      modalInstance.show();
    } else {
      item.active = false;
      modalInstance.hide();
    }
  }

  watch(props, () => {
    updateLocation();
  }, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(__props.program.custom_key?.configs?.month_activity_count?.value), 1),
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(__props.program.custom_key?.configs?.month_activity_member_count?.value), 1),
              _hoisted_16
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(__props.program.custom_key?.configs?.month_activity_collection_weight?.value), 1),
              _hoisted_21
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _hoisted_24,
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("img", {
            src: _unref(isMobileApp) ? require('../../images/map-mobile.png') : require('../../images/map.png'),
            class: "bg"
          }, null, 8, _hoisted_27),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mapLocationList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["location", { 'show': item.show }]),
              style: _normalizeStyle([getLocationStyle(item)]),
              onClick: ($event: any) => (handleClickLocationName(item)),
              onMouseenter: ($event: any) => (handleHoverLocationName(item, true)),
              onMouseleave: ($event: any) => (handleHoverLocationName(item, false))
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("img", {
                  src: getLocationIcon(item),
                  class: "icon"
                }, null, 8, _hoisted_30),
                _withDirectives(_createElementVNode("div", _hoisted_31, null, 512), [
                  [_vShow, item.active]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("img", {
                      class: "mobile-board-close d-md-none",
                      src: _imports_2,
                      onClick: _withModifiers(($event: any) => (triggerLocation(item)), ["stop"])
                    }, null, 8, _hoisted_34),
                    _createElementVNode("div", {
                      class: _normalizeClass(["location-text-wrapper", [`location-text-wrapper-${item.name.length}`]])
                    }, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(item.name), 1),
                      _createElementVNode("img", {
                        class: "location-text-icon d-none d-md-block",
                        src: item.show ? require('../../images/close.png') : require('../../images/add.png'),
                        onClick: _withModifiers(($event: any) => (triggerLocation(item)), ["stop"])
                      }, null, 8, _hoisted_36)
                    ], 2),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, _toDisplayString(item.activityCount), 1),
                        _hoisted_41
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("span", _hoisted_45, _toDisplayString(item.joinCount), 1),
                        _hoisted_46
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("span", _hoisted_50, _toDisplayString(item.collectionCount), 1),
                        _hoisted_51
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, item.show]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["location-text-wrapper", [`location-text-wrapper-${item.name.length}`]])
                }, [
                  _createElementVNode("span", _hoisted_52, _toDisplayString(item.name), 1),
                  _createElementVNode("img", {
                    class: "location-text-icon",
                    src: item.show ? require('../../images/close.png') : require('../../images/add.png'),
                    onClick: _withModifiers(($event: any) => (triggerLocation(item)), ["stop"])
                  }, null, 8, _hoisted_53)
                ], 2), [
                  [_vShow, item.active && !item.show]
                ])
              ])
            ], 46, _hoisted_28))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _hoisted_58,
            _createTextVNode("참여한 " + _toDisplayString(__props.program.custom_key?.configs?.tab3_section_3_participate_count?.value) + " 님 ", 1)
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("img", {
              src: __props.program.custom_key?.configs?.tab3_image_mobile?.value || require('./images/tab-3-image-mobile.png')
            }, null, 8, _hoisted_60)
          ])
        ]),
        _hoisted_61,
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("img", {
              src: __props.program.custom_key?.configs?.month_activity_image_1?.value || require('./images/tab3-banner-1.png'),
              class: "banner"
            }, null, 8, _hoisted_65),
            _createElementVNode("img", {
              src: __props.program.custom_key?.configs?.month_activity_image_2?.value || require('./images/tab3-banner-1.png'),
              class: "banner"
            }, null, 8, _hoisted_66),
            _createElementVNode("img", {
              src: __props.program.custom_key?.configs?.month_activity_image_3?.value || require('./images/tab3-banner-1.png'),
              class: "banner"
            }, null, 8, _hoisted_67),
            _createElementVNode("img", {
              src: __props.program.custom_key?.configs?.month_activity_image_4?.value || require('./images/tab3-banner-1.png'),
              class: "banner"
            }, null, 8, _hoisted_68)
          ]),
          _createVNode(EmartBtn, {
            target: "_blank",
            href: "https://form.office.naver.com/form/responseView.cmd?formkey=OTgzYmQ0MDUtM2RiMC00MWYwLTkwYjQtMGU0NTdjYzRjZjc5&sourceId=urlshare"
          }, {
            default: _withCtx(() => [
              _hoisted_69,
              _hoisted_70,
              _hoisted_71
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_72, [
        _hoisted_73,
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, " 이달의 바다 활동에 참여한 " + _toDisplayString(__props.program.custom_key?.configs?.tab3_section_3_participate_count?.value) + " 님 ", 1),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("img", {
              src: __props.program.custom_key?.configs?.tab3_image?.value || require('./images/tab3-image.png')
            }, null, 8, _hoisted_77)
          ]),
          _hoisted_78,
          _createVNode(SwiperVue, {
            "custom-key": __props.program.custom_key
          }, null, 8, ["custom-key"]),
          _createVNode(EmartBtn, {
            target: "_blank",
            href: "https://form.office.naver.com/form/responseView.cmd?formkey=OTgzYmQ0MDUtM2RiMC00MWYwLTkwYjQtMGU0NTdjYzRjZjc5&sourceId=urlshare"
          }, {
            default: _withCtx(() => [
              _hoisted_79,
              _hoisted_80,
              _hoisted_81
            ]),
            _: 1
          })
        ]),
        _hoisted_82
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "modalRef",
      ref: modalRef,
      class: "modal fade"
    }, _hoisted_84, 512),
    _createVNode(WaitDialogVue, {
      modelValue: showWaitDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showWaitDialog).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})